<template>
  <div id="container" class="mainBox">
    <nyTit pathUrl="/gaobiaoFarmlandDisplay" :nextShow="true" />
    <h5 class="h5">物联网项目展示</h5>

    <div class="content">
      <div class="left">
        <div class="subTit1"><span>气像数据模块</span></div>
        <div class="qx_top flex_wrap">
          <div class="qx_top_left flex_column">
            <div class="subTit2"><span>未来7天风速预测</span></div>
            <div class="ggtxt">
              <div v-if="state.jsleftData.length == 0" class="kong">
                <img src="../assets/img/xiaomai/jiazi.gif" style="width: 50px" />加载中
              </div>
              <Left_fs :listData="state.fsData" v-else />
            </div>
          </div>
          <div class="qx_top_right">
            <txtScroll v-if="state.zwxleftData.length > 0">
              <div v-for="(item, index) in state.zwxleftData" :key="index" class="scroll_item">
                <span class="d1">提醒</span>
                <span class="d3">{{ item.date }}</span>
                <span class="d2">{{ item.index }}</span>
                <span class="d2">紫外线：{{ item.desc }}</span>
              </div>
            </txtScroll>
          </div>
        </div>

        <div class="qx_down ggtxt flex_column">
          <div class="qx_down_bt">
            <div class="bt1" :class="{ cur: state.curWeather == 0 }" @click="clickWd(0)">
              未来24小时
            </div>
            <div class="bt1" :class="{ cur: state.curWeather == 1 }" @click="clickWd(1)">
              未来15天
            </div>
          </div>
          <div class="ggtxt" v-if="state.showDiv1">
            <div v-if="state.weather[0].xLabel.length == 0" class="kong">
              <img src="../assets/img/xiaomai/jiazi.gif" style="width: 50px" />加载中
            </div>
            <leftline :listData="state.weather[state.curWeather]" v-else />
          </div>
        </div>
      </div>

      <div class="center">
        <div class="subTit1">
          <span>物联网实时监控画面</span>
        </div>
        <MonitorGrid />
      </div>

      <div class="right flex_column">
        <div class="right-cols">
          <div class="right-col">
            <div class="subTit1"><span>物联网环境参数</span></div>
            <EnvironmentParams :iot-data="state.iotData" />
          </div>
          <div class="right-col">
            <div class="subTit1"><span>物联网实时采集数据</span></div>
            <RealtimeCollectData :iot-data="state.iotData" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import axios from "axios";
import { reactive, onMounted } from "vue";
import leftline from "../components/Qixiang/leftline.vue";
import Left_fs from "../components/Qixiang/left_fs.vue";
import nyTit from "@/components/nyTit";
import txtScroll from "../components/xiaofeiChanpin/txtScroll.vue";
import MonitorGrid from "@/components/wulianwangProject/MonitorGrid.vue";
import EnvironmentParams from "@/components/wulianwangProject/EnvironmentParams.vue";
import RealtimeCollectData from "@/components/wulianwangProject/RealtimeCollectData.vue";

const state = reactive({
  fsData: [],
  jsleftData: [],
  weather: [
    {
      xLabel: [],
      dataValue: [],
    },
    {
      xLabel: [],
      dataValue: [],
    },
  ],
  curWeather: 0,
  showDiv1: true,
  zwxleftData: [],
  iotData: {
    hours: [],
    airTemperature: [],
    airHumidity: [],
    lightIntensity: [],
    soilTemperature: [],
    soilMoisture: [],
    realtimeLight: 0,
  },
});

function clickWd(index) {
  state.showDiv1 = false;
  state.curWeather = index;
  setTimeout(() => {
    state.showDiv1 = true;
  }, 200);
}

function getData() {
  axios
    .get("https://zhfarm.laicunwang.com/api/environment/shangcaiqxCachedata", {
      params: {
        sign: "c4c6cff9b7ec6b87fa953f77ec7e624b",
      },
    })
    .then((res) => {
      const data = res.data.data || {};
      const data1 = data.data1 || {};
      const data2 = data.data2 || {};
      const data5 = data.data5 || {};
      const data6 = data.data6 || {};
      const data7 = data.data7 || [];
      const historyData1 = data1.HistorydataResult || {};
      const historyData2 = data2.HistorydataResult || {};
      const hours =
        data1.hoursResulttime?.timeInfo || data2.hoursResulttime?.timeInfo || [];

      state.iotData.hours = Array.isArray(hours) ? hours : [];
      state.iotData.airTemperature = Array.isArray(historyData1.air_temperature)
        ? historyData1.air_temperature
        : [];
      state.iotData.airHumidity = Array.isArray(historyData1.air_humidity)
        ? historyData1.air_humidity
        : [];
      state.iotData.lightIntensity = Array.isArray(historyData1.light_intensity)
        ? historyData1.light_intensity
        : [];
      state.iotData.soilTemperature = Array.isArray(historyData2.soil_temperature)
        ? historyData2.soil_temperature
        : [];
      state.iotData.soilMoisture = Array.isArray(historyData2.soil_moisture)
        ? historyData2.soil_moisture
        : [];
      state.iotData.realtimeLight = Number(data1.lastDatas?.[0]?.light_intensity) || 0;

      if (data7.length > 0) {
        state.fsData = data7.slice(0, 7).map((item) => ({
          time: item.time || item.date || "",
          force: item.day_wind_power || "",
          direction: item.day_wind_direction || "",
        }));
      }

      if (data5.raw && data5.raw.day7 && data5.dates) {
        const day7Data = data5.raw.day7;
        state.zwxleftData = data5.dates.slice(0, 7).map((date, index) => {
          const uvTitle = day7Data[index]?.live?.uv?.title || "";
          return {
            date,
            index: data5.weathers?.[index] || "",
            desc: uvTitle,
          };
        });
      }

      if (data5.dates && data5.precipitations) {
        state.jsleftData = [
          data5.dates.slice(0, 7),
          data5.precipitations.slice(0, 7),
        ];
      }

      if (data6.hours && data6.temps) {
        state.weather[0].xLabel = data6.hours.slice(0, 24);
        state.weather[0].dataValue = data6.temps.slice(0, 24);
      }

      if (data5.dates && data5.temps) {
        state.weather[1].xLabel = data5.dates.slice(0, 15);
        state.weather[1].dataValue = data5.temps.slice(0, 15);
      }
    });
}

onMounted(() => {
  getData();
});
</script>

<style lang="less" scoped>
.h5 {
  position: absolute;
  top: 150px;
  left: 100px;
  z-index: 999;
  font-size: 46px;
  color: #f3fcff;
  letter-spacing: 5px;
  text-align: left;
  text-shadow: 0 0 5px rgba(21, 241, 187, 0.5), 0 0 10px rgba(21, 241, 187, 0.8),
    0 0 20px rgba(21, 241, 187, 1);
}

.kong {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;

  img {
    margin-bottom: 20px;
  }
}

.mainBox {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  background: url("../assets/img/plantmoxing/new/bj.png") no-repeat top center;
  background-size: 100% 100%;
  display: flex;

  .content {
    width: 100%;
    height: calc(100% - 150px);
    position: absolute;
    top: 150px;
    display: flex;
    padding: 0 30px 50px;
    box-sizing: border-box;

    .flex_column {
      display: flex;
      flex-direction: column;
    }

    .flex_wrap {
      display: flex;
    }

    .ggtxt {
      width: 100%;
      flex: 1;
      min-height: 0;
    }

    .subTit1 {
      width: 100%;
      height: 130px;
      line-height: 40px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xiaomai/bt.png")
        no-repeat center bottom;
      color: #fff;
      font-size: 40px;
      margin: 20px auto 0;

      span {
        background: linear-gradient(to bottom, #fff 25%, #ffd791 95%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-weight: bold;
      }
    }

    .subTit2 {
      width: 100%;
      height: 66px;
      line-height: 20px;
      padding-left: 40px;
      box-sizing: border-box;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xiaomai/xbt.png")
        no-repeat left bottom;
      font-size: 30px;
      text-align: left;
      color: rgba(254, 254, 254, 1);
    }

    .left,
    .right {
      width: 2173px;
      height: 100%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      background: #071315;
    }

    .left {
      padding-left: 70px;
      padding-right: 70px;

      .qx_top {
        width: 100%;
        height: 550px;

        .qx_top_left {
          width: 1000px;
          height: 100%;
        }

        .qx_top_right {
          height: 100%;
          flex: 1;

          ::v-deep .main_container {
            height: 520px;
          }

          .scroll_item {
            width: 100%;
            display: flex;
            align-items: center;
            margin: 30px 0;
          }

          span {
            height: 70px;
            font-size: 36px;
            line-height: 70px;
            text-align: left;
          }

          .d1 {
            width: 150px;
            background-color: rgba(197, 118, 25, 0.3);
            margin-left: 50px;
            color: #ff9023;
            text-align: center;
          }

          .d2 {
            color: #fff;
            margin: 0 50px;
          }

          .d3 {
            width: 100px;
            height: 70px;
            color: #fff;
            margin-left: 50px;
          }
        }
      }

      .qx_down {
        margin-top: 15px;

        .qx_down_bt {
          width: 100%;
          height: 90px;
          display: flex;
          justify-content: center;
          align-items: center;

          .bt1 {
            width: 180px;
            height: 90px;
            background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/qixiang/wl.png")
              no-repeat top center;
            background-size: 100% 100%;
            margin: 0 100px;
            color: #fff;
            font-size: 26px;
            line-height: 90px;
            cursor: pointer;
          }

          .cur {
            color: #00e5ed;
          }
        }
      }
    }

    .center {
      flex: 1;
      min-width: 0;
      min-height: 0;
      height: 100%;
      display: flex;
      flex-direction: column;
      padding-top: 50px;
      box-sizing: border-box;
      overflow: hidden;
    }

    .right {
      padding: 0 70px;

      .right-cols {
        width: 100%;
        height: 100%;
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 54px;
      }

      .right-col {
        min-width: 0;
        min-height: 0;
        display: flex;
        flex-direction: column;
      }
    }
  }
}

::v-deep .row-item {
  border-bottom: 1px solid;
  border-image: linear-gradient(
      to right,
      rgba(255, 255, 255, 0.05) 10%,
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.05)
    )
    1;
}
</style>
